export enum KostGender {
  Male = 'male',
  Female = 'female',
  Mixed = 'mixed',
}
